module.exports = {"name":"Dotácia z ministerstva","icon":"<i class='material-icons'>art_track</i>","widget":[{"type":"image","initData":{"img":"http://www.minedu.sk/images/logo-minedu-sk.svg"},"width":300,"height":95},{"type":"pure-html","initData":{"html":"Popis k obrazku"}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/ministry-grant/ministry-grant.json
// module id = 371
// module chunks = 0